import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslocoModule } from '@jsverse/transloco';
import { DeletionRequestService } from '../../../../../../libs/shared/src/lib/services/deletion-request.service';
import { InputComponent } from '../input/input.component';

export interface DeleteAccountModalData {
  // No additional data needed for user account deletion
}

export interface DeleteAccountModalResult {
  confirmed: boolean;
  reason?: string;
}

@Component({
  selector: 'app-delete-account-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatCheckboxModule,
    TranslocoModule,
    InputComponent
  ],
  templateUrl: './delete-account-modal.component.html',
  styleUrls: ['./delete-account-modal.component.scss']
})
export class DeleteAccountModalComponent {
  confirmationText = '';
  reason = '';
  finalConfirmation = false;


  constructor(
    public dialogRef: MatDialogRef<DeleteAccountModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteAccountModalData,
    private deletionRequestService: DeletionRequestService
  ) {}

  get isConfirmationValid(): boolean {
    return this.confirmationText.toUpperCase() === 'DELETE';
  }

  get canSubmit(): boolean {
    return this.isConfirmationValid &&
           this.finalConfirmation;
  }

  onCancel(): void {
    this.dialogRef.close({ confirmed: false });
  }

  onConfirm(): void {
    if (this.canSubmit) {
      this.dialogRef.close({
        confirmed: true,
        reason: this.reason || undefined
      });
    }
  }

}
